import { render, staticRenderFns } from "./oxySnap.vue?vue&type=template&id=7885199a&scoped=true&"
import script from "./oxySnap.vue?vue&type=script&lang=js&"
export * from "./oxySnap.vue?vue&type=script&lang=js&"
import style0 from "./oxySnap.vue?vue&type=style&index=0&id=7885199a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7885199a",
  null
  
)

export default component.exports